import React from 'react';
import { Link } from 'react-router-dom';

const Hero: React.FC = () => {
  return (
    <section 
      className="hero-section w-full px-6 md:px-12 lg:px-20 py-16 md:py-24"
      style={{ 
        background: 'linear-gradient(to bottom, #0c0d1f, #1b1324)' 
      }}
    >
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
        {/* Left Side - Laptop Visual */}
        <div className="relative order-2 md:order-1">
          <div className="relative">
            {/* 70% OFF Badge */}
            <div className="absolute -top-4 -left-4 z-30 bg-blue-500 text-white px-4 py-2 rounded-md font-bold text-sm shadow-lg">
              70% OFF!
            </div>
            
            {/* Laptop Visual with video on screen */}
            <div className="relative w-full">
              <img 
                src="/images/laptop.png" 
                alt="Laptop" 
                className="w-full h-auto object-contain drop-shadow-2xl relative z-0"
                style={{ filter: 'drop-shadow(0 25px 50px rgba(0, 0, 0, 0.5))' }}
              />
              {/* Video on laptop screen - positioned to fill the white screen area */}
              <div
                className="absolute z-10 overflow-hidden rounded-sm"
                style={{
                  left: '12.8%',
                  top: '4%',
                  width: '74.6%',
                  height: '77%',
                }}
              >
                <video
                  src="/videos/Adblocker-Video-Reverse-1.mp4"
                  className="w-full h-full object-cover"
                  autoPlay
                  muted
                  loop
                  playsInline
                />
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Content */}
        <div className="order-1 md:order-2">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-8 leading-tight" style={{ color: '#ccd6f3' }}>
            We were sick of internet ads. 
          </h1>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-8 leading-tight">
            So we made a simple <br />app that blocks them.
          </h1>

          {/* Benefits List */}
          <ul className="space-y-4 mb-8">
            <li className="flex items-start gap-3 text-white">
              <img 
                src="/images/tick.png" 
                alt="Checkmark" 
                className="flex-shrink-0 mt-0.5"
                style={{ width: '1rem', height: '1rem' }}
              />
              <span className="text-base" style={{ color: '#536e81' }}>Block nearly all ads instantly (including YouTube).</span>
            </li>
            <li className="flex items-start gap-3 text-white">
              <img 
                src="/images/tick.png" 
                alt="Checkmark" 
                className="flex-shrink-0 mt-0.5"
                style={{ width: '1rem', height: '1rem' }}
              />
              <span className="text-base" style={{ color: '#536e81' }}>Load pages 2x faster.</span>
            </li>
            <li className="flex items-start gap-3 text-white">
              <img 
                src="/images/tick.png" 
                alt="Checkmark" 
                className="flex-shrink-0 mt-0.5"
                style={{ width: '1rem', height: '1rem' }}
              />
              <span className="text-base" style={{ color: '#536e81' }}>Block trackers and cookies.</span>
            </li>
            <li className="flex items-start gap-3 text-white">
              <img 
                src="/images/tick.png" 
                alt="Checkmark" 
                className="flex-shrink-0 mt-0.5"
                style={{ width: '1rem', height: '1rem' }}
              />
              <span className="text-base" style={{ color: '#536e81' }}>Browse the internet in peace.</span>
            </li>
          </ul>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Link 
              to="/payment"
              className="btn-adsmash-primary text-white px-8 py-4 rounded-md font-semibold text-base transition-all shadow-lg text-center"
            >
              Get it now - $3/month
            </Link>
            <div 
              className="hidden md:inline-flex bg-blue-500 text-white px-8 py-4 rounded-md font-semibold text-base shadow-lg text-center pointer-events-none select-none"
              aria-hidden="true"
            >
              70% OFF!
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

